import styled from 'styled-components';
import Component from './component';

export default styled(Component)`
  .filter {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 48px;
  }
  height: 100%;
`;
